import dayjs from "dayjs";
import "dayjs/locale/nl";
import "dayjs/locale/tr";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isToday from "dayjs/plugin/isToday";
import isoWeek from "dayjs/plugin/isoWeek";
import localizedFormat from "dayjs/plugin/localizedFormat";
import weekOfYear from "dayjs/plugin/weekOfYear";

// Extend dayjs with useful plugins
dayjs.extend(customParseFormat);
dayjs.extend(isoWeek);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(localizedFormat);
// import 'dayjs/locale/de' // ES 2015
dayjs.locale("nl");
dayjs.locale("tr");
dayjs.extend(weekOfYear);
dayjs.extend(isToday);
dayjs.extend(duration);
